/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Status from 'astro/server/status';


export default class extends Status
{
  install ()
  {
    this.getParent().getStatusProxy().onInstallDisband(this);
  }
};
